const Appdispute = () => import('@/module/index/layout/Appdispute.vue')
const onlineMediation = () => import('@/module/index/pages/dtuMediation/onlineMediation.vue')
const chatOnline = () => import('@/module/index/pages/consultation/chatOnline.vue')
const pgbg = () => import('@/module/index/pages/dtuMediation/applyAssess.vue')
export default {
  path: '/',
  component: Appdispute,
  meta: {
    title: ''
  },
  children: [{
    path: '/consultation/chatOnline/:id/:step', // 人工咨询--聊天
    name: 'chatOnline',
    component: chatOnline
  },
  {
    path: '/onlineMediation/:stepId/:id', // 人工咨询
    name: 'onlineMediation',
    component: onlineMediation
  },
  {
    path: '/applyBg/:stepId/:id', // 人工咨询
    name: 'applyBg',
    component: pgbg
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/onlineMediation.js